import { createAxiosHandler } from "@souche-f2e/web-sdk-axios-functions-helper";
const axiosInst = createAxiosHandler({ env: process.env.ENV || 'dev' });
function getAllStoreList(payload) {
    return axiosInst({
        module: 'baseStoreDirect',
        method: 'POST',
        uri: '/store/storeInfoApi/getAllStoreList.json',
        data: JSON.stringify(payload),
    });
}
export default {
    getAllStoreList
};
